/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_PayloadInputs */

const cs_settings_automation_payload = /** @type {(inputs: Settings_Automation_PayloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payload`)
};

const en_settings_automation_payload = /** @type {(inputs: Settings_Automation_PayloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payload`)
};

/**
* | output |
* | --- |
* | "Payload" |
*
* @param {Settings_Automation_PayloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_payload = /** @type {((inputs?: Settings_Automation_PayloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_PayloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_payload(inputs)
	return cs_settings_automation_payload(inputs)
});